import { useTheme } from '../../../../hooks/useTheme';

import { ReactComponent as InfoIcon } from '../../../../icons/info.svg';

import OkDialog from '../ok-dialog/OkDialog';

const InfoDialog = ({ isOpen, title, message, onClick, onClose }) => {
  const { getThemeVariable } = useTheme();

  return (
    <OkDialog
      isOpen={isOpen}
      title={title}
      message={message}
      onClick={onClick}
      onClose={onClose}
      icon={<InfoIcon width={56} height={56} style={{ color: getThemeVariable('status-info') }} />}
    />
  );
};

export default InfoDialog;
